export const navItems = [
    {
        text: "Jobs",
        href: "/search",
        outlined: false,
        dataHeaderLink: "jobs",
        subNavItems: [
            {
                text: "Account Management",
                href: "/search/category/account_management/",
                dataHeaderLink: "account_management",
                showOnMobile: false
            },
            {
                text: "Accounting and Finance",
                href: "/search/category/accounting_finance/",
                dataHeaderLink: "accounting_finance",
                showOnMobile: false
            },
            {
                text: "Administration and Office",
                href: "/search/category/administration_office/",
                dataHeaderLink: "administration_office",
                showOnMobile: true
            },
            {
                text: "Advertising and Marketing",
                href: "/search/category/advertising_marketing/",
                dataHeaderLink: "advertising_marketing",
                showOnMobile: true
            },
            {
                text: "Arts",
                href: "/search/category/arts/",
                dataHeaderLink: "arts",
                showOnMobile: false
            },
            {
                text: "Business Operations",
                href: "/search/category/business_operations/",
                dataHeaderLink: "business_operations",
                showOnMobile: false
            },
            {
                text: "Computer and IT",
                href: "/search/category/computer_it/",
                dataHeaderLink: "computer_it",
                showOnMobile: true
            },
            {
                text: "Customer Service",
                href: "/search/category/customer_service/",
                dataHeaderLink: "customer_service",
                showOnMobile: true
            },
            {
                text: "Data and Analytics",
                href: "/search/category/data_analytics/",
                dataHeaderLink: "data_analytics",
                showOnMobile: false
            },
            {
                text: "Design and UX",
                href: "/search/category/design_ux/",
                dataHeaderLink: "design_ux",
                showOnMobile: true
            },
            {
                text: "Education",
                href: "/search/category/education/",
                dataHeaderLink: "education",
                showOnMobile: false
            },
            {
                text: "Healthcare",
                href: "/search/category/healthcare/",
                dataHeaderLink: "healthcare",
                showOnMobile: false
            },
            {
                text: "Human Resources and Recruitment",
                href: "/search/category/human_resources_recruitment/",
                dataHeaderLink: "human_resources_recruitment",
                showOnMobile: true
            },
            {
                text: "Management",
                href: "/search/category/management/",
                dataHeaderLink: "management",
                showOnMobile: false
            },
            {
                text: "Media, PR, and Communications",
                href: "/search/category/media_pr_communications/",
                dataHeaderLink: "media_pr_communications",
                showOnMobile: false
            },
            {
                text: "Product Management",
                href: "/search/category/product_management/",
                dataHeaderLink: "product_management",
                showOnMobile: true
            },
            {
                text: "Project Management",
                href: "/search/category/project_management/",
                dataHeaderLink: "project_management",
                showOnMobile: false
            },
            {
                text: "Sales",
                href: "/search/category/sales/",
                dataHeaderLink: "sales",
                showOnMobile: true
            },
            {
                text: "Software Engineering",
                href: "/search/category/software_engineering/",
                dataHeaderLink: "software_engineering",
                showOnMobile: true
            },
            {
                text: "Writing and Editing",
                href: "/search/category/writing_editing/",
                dataHeaderLink: "writing_editing",
                showOnMobile: false
            }
        ]
    },
    {
        text: "Companies",
        href: "/companies",
        outlined: false,
        dataHeaderLink: "companies"
    },
    {
        text: "Advice",
        href: "/advice",
        outlined: false,
        dataHeaderLink: "advice"
    },
    {
        text: "Coaching",
        href: "/coaching",
        outlined: false,
        dataHeaderLink: "coaching"
    },
    {
        text: "Newsletter",
        href: "#newsletter",
        outlined: false,
        dataHeaderLink: "newsletter"
    },
    {
        text: "Employers",
        href: "/employers",
        outlined: true,
        dataHeaderLink: "employers"
    },
];
export const genUserNavItems = (showBookings, showCompanySettings) => [
    {
        text: "Saved Companies",
        href: "/companies?favorited=true",
        dataHeaderLink: "saved-companies"
    },
    {
        text: "Booking Manager",
        href: "/dashboard/bookings",
        dataHeaderLink: "booking-manager"
    },
    {
        text: "Company Settings",
        href: "/dashboard/bookings",
        dataHeaderLink: "booking-manager"
    },
];
//# sourceMappingURL=navItems.js.map